export default __webpack_public_path__ + "img/7f31e270575a3976ff301403d89a5224.svg";